import { CSSProperties } from 'react'

export const s = {
  root: {
    paddingTop: 39,
    margin: 'auto',
    textAlign: 'center',
  } as CSSProperties,
  description: {
    fontSize: 18,
  } as CSSProperties,
}
